<template>
  <div class="warp-hero w-full py-4 px-4 md:px-[15vw]">
    <div class="container mx-auto relative">
      <transition :name="`slide-${slideDirection}`" mode="out-in">
        <div class="hero-card" :key="berita.id">
          <div class="row">
            <div class="col-12">
              <div class="relative h-[30vh] z-0 md:h-[50vh] overflow-hidden">
                <img
                  :src="berita.gambar"
                  alt="hero"
                  class="w-full h-full object-cover transition-opacity duration-500"
                  @error="handleImageError"
                  @load="handleImageLoad"
                  v-show="!isLoading"
                />
                <div
                  v-if="isLoading"
                  class="flex items-center justify-center h-full"
                >
                  <span class="text-gray-500">Loading...</span>
                </div>
                <div class="button-image absolute inset-0 flex items-center justify-between px-[2vw]">
                  <button
                    @click="prev"
                    class="bg-yellow-400 hover:bg-yellow-500 text-black md:px-[1vw] md:py-[1vw] px-[2vw] py-[2vw] rounded-full z-30"
                  >
                    ◀
                  </button>
                  <button
                    @click="next"
                    class="bg-yellow-400 hover:bg-yellow-500 text-black md:px-[1vw] md:py-[1vw] px-[2vw] py-[2vw] rounded-full z-30"
                  >
                    ▶
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="card-info bg-gradient-to-r from-emerald-700 to-emerald-700/80 px-[3vw] py-2 grid grid-cols-12 items-center 
              min-h-[25vh] md:min-h-[20vh]">
              <div class="col-span-9 text-left">
                <div class="text-amber-400 text-sm font-medium">
                  {{ berita.kategori?.toUpperCase() }}
                </div>
                <h2 class="text-white text-xl font-semibold leading-[4vh] line-clamp-2 md:text-4xl my-[1vh] md:my-[2vh] md:leading-[5vh]">
                  {{ berita.judul }}
                </h2>
                <p class="text-white text-sm font-normal leading-[2.5vh] md:leading-[3vh] md:mt-[1vh] max-w-[80%] line-clamp-2 ">
                  {{ berita.excerpt }}
                </p>
              </div>
              <div class="col-span-3 flex justify-end">
                <img
                  src="@/assets/logo-stikes.png"
                  alt="logo"
                  class="w-[20vw] h-[20vw] md:w-[8vw] md:h-[8vw] md:mr-[1vw] opacity-30 filter grayscale"
                />
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useBeritaStore } from "@/store/beritaStore";

const store = useBeritaStore();
const isLoading = ref(true);
const slideDirection = ref("left"); // Menyimpan arah slide

// Filter berita dengan is_hero: true
const heroBerita = computed(() => {
  return store.berita.filter((item) => item.is_hero === true);
});

const currentIndex = ref(0);

const next = () => {
  slideDirection.value = "left"; // Geser ke kiri untuk next
  if (heroBerita.value.length > 0) {
    currentIndex.value = (currentIndex.value + 1) % heroBerita.value.length;
  }
};

const prev = () => {
  slideDirection.value = "right"; // Geser ke kanan untuk prev
  if (heroBerita.value.length > 0) {
    currentIndex.value =
      (currentIndex.value - 1 + heroBerita.value.length) % heroBerita.value.length;
  }
};

const berita = computed(() => {
  return heroBerita.value[currentIndex.value] || null;
});

const handleImageError = (event) => {
  event.target.src = "@/assets/fallback-image.jpg";
  isLoading.value = false;
};

const handleImageLoad = () => {
  isLoading.value = false;
};

console.log("URL gambar:", berita.value?.judul, berita.value?.gambar);
</script>

<style scoped>
.button-image {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.slide-left-enter-active,
.slide-right-enter-active,
.slide-left-leave-active,
.slide-right-leave-active {
  transition: transform 0.5s ease-in-out;
}

.slide-left-enter-from {
  transform: translateX(150%);
}
.slide-left-leave-to {
  transform: translateX(-150%);
}

.slide-right-enter-from {
  transform: translateX(-150%);
}
.slide-right-leave-to {
  transform: translateX(150%);
}

.hero-card {
  will-change: transform;
  backface-visibility: hidden;
}

</style>
